import PropTypes from "prop-types";
import TextInputField from "../input/TextInput";
import FormInputWrapper from "../form/FormInputWrapper";
import { useFormInput } from "./utils";

const TextInput = ({
    name,
    validations,
    label,
    description,
    helpText,
    className,
    ...rest
}) => {
    const { wrapperProps, inputProps } = useFormInput({
        name,
        validations,
        isControlled: true,
    });

    return (
        <FormInputWrapper
            {...{ label, description, helpText, className }}
            {...wrapperProps}
        >
            <TextInputField {...rest} {...inputProps} />
        </FormInputWrapper>
    );
};

TextInput.propTypes = {
    name: PropTypes.string.isRequired,
    validations: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    helpText: PropTypes.string,
    className: PropTypes.string,
};

export default TextInput;
